import { createAction } from "@reduxjs/toolkit";

export const subscribeToConfig = createAction("subscribeToConfig");
export const unsubscribeToConfig = createAction("unsubscribeFromConfig");
